var _path, _path2, _path3, _rect, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPpt = function SvgPpt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ppt_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    d: "M25.875 25.5c0-.828-.68-1.516-1.488-1.335-.65.146-1.28.388-1.87.72a7.3 7.3 0 0 0-2.566 2.448 7.76 7.76 0 0 0-1.167 3.432 7.86 7.86 0 0 0 .508 3.605 7.5 7.5 0 0 0 2.063 2.928 7 7 0 0 0 3.13 1.558c1.15.24 2.337.18 3.458-.179a7 7 0 0 0 1.894-.943c.653-.46.645-1.385.095-1.964l-3.644-3.836a1.5 1.5 0 0 1-.413-1.033z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    d: "M33.533 33.112c.813.213 1.656-.287 1.703-1.126a8.57 8.57 0 0 0-.846-4.231 8.14 8.14 0 0 0-2.722-3.166c-.7-.477-1.608-.086-1.913.704l-1.791 4.64a1.5 1.5 0 0 0 1.02 1.991z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#FF5E07",
    rx: 4.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.89 18v-6h2.59q.669 0 1.17.264t.779.74q.278.479.278 1.117 0 .645-.287 1.116-.284.472-.8.727-.513.255-1.198.255H8.875v-1.266h1.219q.286 0 .49-.1a.73.73 0 0 0 .313-.29.85.85 0 0 0 .11-.442.83.83 0 0 0-.11-.44.7.7 0 0 0-.314-.28 1.1 1.1 0 0 0-.49-.1H9.52V18zm5.415 0v-6h2.59q.668 0 1.169.264.5.264.779.74.278.479.278 1.117 0 .645-.287 1.116-.285.472-.8.727-.511.255-1.198.255H14.29v-1.266h1.219q.286 0 .49-.1a.73.73 0 0 0 .313-.29.85.85 0 0 0 .111-.442.83.83 0 0 0-.111-.44.7.7 0 0 0-.314-.28 1.1 1.1 0 0 0-.49-.1h-.573V18zm5.25-4.687V12h5.215v1.313h-1.805V18H20.36v-4.687z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ppt_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgPpt;